export const DENOMINATIONS = {
  C1: {
    label: '$0.01',
    value: 0.01,
    name: 'C1',
  },
  C5: {
    label: '$0.05',
    value: 0.05,
    name: 'C5',
  },
  C10: {
    label: '$0.10',
    value: 0.1,
    name: 'C10',
  },
  C25: {
    label: '$0.25',
    value: 0.25,
    name: 'C25',
  },
  C50: {
    label: '$0.50',
    value: 0.5,
    name: 'C50',
  },
  D1: {
    label: '$1.00',
    value: 1,
    name: 'D1',
  },
  D5: {
    label: '$5',
    value: 5,
    name: 'D5',
  },
  D10: {
    label: '$10',
    value: 10,
    name: 'D10',
  },
  D20: {
    label: '$20',
    value: 20,
    name: 'D20',
  },
  D50: {
    label: '$50',
    value: 50,
    name: 'D50',
  },
  D100: {
    label: '$100',
    value: 100,
    name: 'D100',
  },
};

export const CENT_DENOMINATION_PREFIX = 'C';

export const DOLLAR_DENOMINATION_PREFIX = 'D';

const initialDenominationsState = {};

Object.values(DENOMINATIONS).forEach(d => {
  initialDenominationsState[d.name] = 0;
});

export const INITIAL_DENOMINATIONS_STATE = initialDenominationsState;

export const INVALID_AMOUNT_MESSAGE = {
  title: 'Point of Sale',
  message: 'Value cannot be greater than 999.99',
};



// WEBPACK FOOTER //
// ./src/common/Components/CashCalculator/constants/index.js